import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { DataService } from '../../../shared/dataservice.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog'
import { ScmIP, SaveStatusObj, SOModule, SaveEventType, SSOStatus, SubSalesOrder, SalesOrder, ActualDateChange, ActualDateToken, PlannedDateToken, ValidationItem, ValidationSummary } from '../../../shared/misc-classes';
import { ActualDateDialog } from '../../../dialogs/actual-date-dialog/actual-date-dialog';
import { ValidationDialog } from '../../../dialogs/validation-dialog/validation-dialog';

@Component({
  selector: 'scm',
  templateUrl: './scm.component.html',
  styleUrls: ['./scm.component.css']
})
export class ScmComponent implements OnInit, OnChanges {

  @Input() scmObj: ScmIP;
  @Input() soLockObtained:boolean;
  @Input() loadCounter:SalesOrder;
  @Output() updateSubSalesOrder: EventEmitter<SaveStatusObj> = new EventEmitter();
  disableForm: boolean = true;
  MesageForm:boolean = false;

  modifyPlanDate:boolean = true;
  modifyReqDate:boolean = true;
  public _SSOStatus = SSOStatus;
  inputDisableMessage:string = 'This form is not yet enabled';
  inputMessage:string = '';

  Hvr:any = {};

  constructor(public _dataService: DataService, public dialog: MatDialog) { }

  ngOnInit() {
    this.modifyPlanDate = this._dataService.modifyPlanDate;
    this.modifyReqDate = this._dataService.modifyReqDate;
  }
  ngOnChanges() {
    this.disableForm = true;
    this.MesageForm = false;
    if(this.soLockObtained == false){
      this.inputDisableMessage = "You can't Edit, Sale Order Lock NOT obtained.";
    }
    // else if (!this.scmObj.isProjectLive) {
    //   this.inputDisableMessage = "Project is on HOLD or TO BE CANCELLED";
    // }
    else if (!this.scmObj.isInputEnabled) {
      this.inputDisableMessage = "This form is not yet enabled";
    }
    else if (!this._dataService.hasSCMEditAccess) {
      this.inputDisableMessage = "You don't have EDIT ACCESS.";
    }
    else {
      this.disableForm = false;
    }
   }
  saveSso(_submitToNextSection:boolean,ssoSubmitTo:SSOStatus = SSOStatus.Not_Started){
    if(this.updateSubSalesOrder){
      this.updateSubSalesOrder.emit(new SaveStatusObj(SOModule.Sub_Orders, 
          (_submitToNextSection == true ? SaveEventType.Submit_To_Next:SaveEventType.Save_Data),
          null,
          ssoSubmitTo
        ));
    }
  }
  deleteSSo(_deleteSO:boolean){
    if(this.updateSubSalesOrder){
      this.updateSubSalesOrder.emit(new SaveStatusObj(SOModule.Sub_Orders, SaveEventType.Delete_SubSale_Order));
    }
  }
  actualDateChangeHandler(_actDateHeader:string,_actDate:Date,_actDateChanged:Date,_actTokenKeyName:string,_plndDateHeader:string,_plndDate:Date,):void{
    let _actDateChangeObj:ActualDateChange = new ActualDateChange("Additional Comment", _plndDateHeader, _plndDate, _actDateHeader, 
                                                              _actDateChanged, this.scmObj[_actTokenKeyName].addNotes);
    let dialogRef = this.dialog.open(ActualDateDialog, {
      width: '50%',
      data: _actDateChangeObj
    });
    let _prevActualDate:Date = this.scmObj[_actTokenKeyName].actualDate;
    this.scmObj[_actTokenKeyName].actualDate = _actDateChanged;
    dialogRef.afterClosed().subscribe((confirm) => {
      if (confirm == true) {
        this.scmObj[_actTokenKeyName].actualDate = _actDateChangeObj.actualDate;
        var changedDate: Date = null;
        if(_actDateChangeObj.actualDate != null){
          changedDate = new Date(_actDateChangeObj.actualDate.getTime());
        }
        this.scmObj[_actTokenKeyName] = 
          new ActualDateToken(changedDate, true, _plndDate, _actDateChangeObj.comments,this._dataService.userId);
      }
      else {
        this.scmObj[_actTokenKeyName].actualDate = _prevActualDate;
      }
    });
  }

  plannedDateChangeHandler(_plndDateHeader:string, _plndTokenKeyName:string,_plndDate:Date,_plndDateChanged:Date):void{
    let _plndDateChangeObj:ActualDateChange = new ActualDateChange("Why is the planned date changed ?", _plndDateHeader + "(existing)", 
                                                  _plndDate, _plndDateHeader + "(edited)", _plndDateChanged, this.scmObj[_plndTokenKeyName].addNotes);
    let dialogRef = this.dialog.open(ActualDateDialog, {
      width: '50%',
      data: _plndDateChangeObj
    });
    this.scmObj[_plndTokenKeyName].plannedDate = _plndDateChanged;
    dialogRef.afterClosed().subscribe((confirm) => {
      if (confirm == true) {
        this.scmObj[_plndTokenKeyName] = 
          new PlannedDateToken(new Date(_plndDateChanged.getTime()), true, null, _plndDateChangeObj.comments,this._dataService.userId);
      }
      else {
        this.scmObj[_plndTokenKeyName].plannedDate = _plndDate;
      }
    });
  }

  showSoValidation(){
    let _validList:Array<ValidationItem> = [
    ] ;
    _validList.push(new ValidationItem("CT Finalization From SCM Actual", (this.scmObj.ctFinalizationFromSCMActualDate ? true : false)," required for Engg procurement." )  );
    if(this.scmObj.isSplMatFinDatesEnabled && this.scmObj.isSplMaterialpriceActualdatesGivenInSCM != true){
      _validList.push(new ValidationItem("Special Material Price Actual Date required", (this.scmObj.splMatFGivenbySCMtoEnggActualDate ? true : false)," required for Engg procurement." )  )
    }
    console.log(_validList);

    let vSummaryObj:ValidationSummary = new ValidationSummary("Validation Summary.",_validList);
    
    this.dialog.open(ValidationDialog, {
      width: '50%',
      data: vSummaryObj
    });
  }

  reloadData() {
    if (this.updateSubSalesOrder) {
      this.updateSubSalesOrder.emit(new SaveStatusObj(SOModule.Sub_Orders, SaveEventType.Reload_Data));
    }
  }
}
